import { render, staticRenderFns } from "./docs-embed.vue?vue&type=template&id=f51f4aba&scoped=true"
import script from "./docs-embed.vue?vue&type=script&lang=js"
export * from "./docs-embed.vue?vue&type=script&lang=js"
import style0 from "./docs-embed.vue?vue&type=style&index=0&id=f51f4aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51f4aba",
  null
  
)

export default component.exports